import React from 'react'
import { Helmet } from 'react-helmet-async'

const getNextPrevUrl = ({ currentPage, isNext, isPrevious }) => {
   if (typeof window === 'undefined' || isNaN(currentPage)) return ''

   const url = new URL(window.location.href)
   const queryParams = url.searchParams

   const pageNumber = isNext
      ? currentPage + 1
      : isPrevious
      ? currentPage - 1
      : currentPage

   if (pageNumber === 1) {
      queryParams.delete('page')
   } else {
      queryParams.set('page', pageNumber)
   }

   return `${url.origin}${url.pathname}?${queryParams.toString()}`
}

const NextPrevPageMetaLinks = ({ currentPage, totalPages }) => {
   const isFirstPage = currentPage === 1
   const isLastPage = currentPage === totalPages

   const nextLinkUrl = !isLastPage
      ? getNextPrevUrl({ currentPage, isNext: true })
      : null

   const previousLinkUrl = !isFirstPage
      ? getNextPrevUrl({ currentPage, isPrevious: true })
      : null

   return (
      <Helmet>
         <link rel="next" href={nextLinkUrl} />
         <link rel="prev" href={previousLinkUrl} />
      </Helmet>
   )
}

export default NextPrevPageMetaLinks
